import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacyPanel.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PrivacyPanelComponent {
}
